import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper
} from "@material-ui/core";

const styles = theme => ({
  mainRequest: {
    display: "flex",
    flexDirection: "column",
    padding: ".5rem",
    flexGrow: 1
  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column"
  },
  textField: {
    marginTop: "1rem"
  },
  formControl: {
    marginTop: "1.5rem"
  },
  mb1: {
    marginBottom: "1.5rem"
  },
  storeGroup: {
    display: "flex"
  },
  storeFilter: {
    marginRight: ".5rem"
  },
  storeSelect: {
    width: "100%"
  },
  storeFilterToggle: {
    whiteSpace: "nowrap",
    marginLeft: ".1rem",
    marginTop: ".75rem",
    marginRight: ".25rem"
  },
  badgecls: {
    // width:25,
    // height:25,
    left: 32
  }
});

class WorkRequest extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
    };
  }

  componentWillMount = () => {};

  fetchFile = () => {
    let url = this.state.isProd
      ? `/api/getFile`
      : `https://localhost:44331/api/getFile`;

    fetch(url)
      .then(function(response) {
        return response.blob();
      })
      .then(function(blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "angel.pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.mainRequest}>
        <Button
          variant="contained"
          color="primary"
          className={[classes.button, classes.mt1, classes.mb0].join(" ")}
          onClick={this.fetchFile}
        >
          Download File
        </Button>
      </Paper>
    );
  }
}

export default withStyles(styles)(WorkRequest);
